// extracted by mini-css-extract-plugin
module.exports = {"page_info_in_boxes":"PageInfoInBoxes_page_info_in_boxes__85MwU"};